/**
 * Map EventType to a Heroicon component (Phase 36.1 D-04).
 *
 * Final icon selection comes from Figma node `2693:80661`. The mapping below
 * is the CONTEXT.md D-04 proposal — Plan 36.1-04 (Figma reconciliation)
 * confirms or revises against the live frame. Same util feeds the
 * SummaryCard icon-circle in EventDetailSheet.
 *
 * Returned components are 24/outline Heroicons; consumers size them via
 * className (typically 20×20 inside a 40×40 type-colored circle, white stroke).
 */
import {
	BeakerIcon,
	CalendarIcon,
	ClipboardDocumentListIcon,
	ClockIcon,
	HeartIcon,
} from "@heroicons/react/24/outline";
import type { ComponentType, SVGProps } from "react";
import type { EventType } from "../../types/event";

export type HeroIconComponent = ComponentType<
	SVGProps<SVGSVGElement> & { title?: string; titleId?: string }
>;

export function getEventTypeIcon(type: EventType): HeroIconComponent {
	switch (type) {
		case "appointment":
			return CalendarIcon;
		case "test":
			return BeakerIcon;
		case "medication":
			return ClockIcon;
		case "cycle":
			return HeartIcon;
		case "admin":
			return ClipboardDocumentListIcon;
		default: {
			const _exhaustive: never = type;
			void _exhaustive;
			return CalendarIcon;
		}
	}
}
